import { render } from "./RenameListAction.vue?vue&type=template&id=19c4eb3a"
import script from "./RenameListAction.vue?vue&type=script&lang=ts"
export * from "./RenameListAction.vue?vue&type=script&lang=ts"
script.render = render

export default script